import React from 'react'

import {css} from '@emotion/core';
import styled from '@emotion/styled';
import { baseDurationTime, breakP } from '../../_style';
import InView from 'react-intersection-observer';

const Container = styled.div`
  ${props => props.isFadeIn && `
    opacity: 0;
    transform: translate3d(0, 50px, 0);
    transition: opacity ${parseFloat(baseDurationTime) * 2}s ease, transform ${parseFloat(baseDurationTime) * 2}s ease;
    will-change: transform, opacity;
    &.is-shown {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  `}
`
export default class InViewWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {isShown: false, windowH: 0, isSp: false};
    this.resizeHandler = this.resizeHandler.bind(this);
  }
  componentDidMount() {
    this.setState({windowH: window.innerHeight, isSp: breakP >= window.innerWidth});
    window.addEventListener('resize', this.resizeHandler);
  }
  componentWillUnmount() {
    this.setState({isShown:  false})
    window.removeEventListener('resize', this.resizeHandler);
  }
  resizeHandler() {
    this.setState({isSp: breakP >= window.innerWidth});
  }
  show() {
    this.setState({isShown: true});
  }
  render() {
    return (
      <InView as={Container} className={this.state.isShown ? 'is-shown' : 'is-hidden'} onChange={(inView, entry) => {
        if (inView) { this.show(); }
      }} rootMargin={!this.state.isSp ? `-${this.state.windowH / 4}px` : '0px'} isFadeIn={this.props.isFadeIn}>
        {this.props.children}
      </InView>
    );
  }
}
